import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Icon from 'shopper/components/Icon';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import Button from '../../Shopper/Button';

import LINKS from 'constants/links';

const PostOfferButton = ({ gaEventCategory }) => {
  const onPostOffer = () => {
    sendEvent({
      action: 'topbar_suggest_offer',
      category: gaEventCategory,
    });
  };

  return (
    <NextLink href={LINKS.NEW_OFFER} prefetch={false} passHref>
      <Button
        aria-label="Postar Oferta"
        as="a"
        icon={<Icon name="add-circle" />}
        onClick={onPostOffer}
      >
        {placeholder('actions.postOffer')}
      </Button>
    </NextLink>
  );
};

PostOfferButton.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default PostOfferButton;
